export const SDK_VERSION = '6.11.0';
